var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Scenario --global-clickable",class:[("state-" + _vm.state)],on:{"click":function($event){return _vm.openScenario()}}})}
var staticRenderFns = []

export { render, staticRenderFns }